

  <header class="header pt-0">
    <div class="container">
      <div class="row align-items-center my-2">
        <div class="col">
          <a  [routerLink]="['/']"><img class="logo" src="assets/img/logo-a.png"></a>
        </div>
        <div class="col-auto">

          <!-- <a *ngIf="!currentUseInfo.name" class="mr-3 header-link"  href="javascript:void(0);"><img src="assets/img/language-icon.png"> En</a> -->
          <a *ngIf="!currentUseInfo.name" class="btn mr-2" [routerLink]="['/auth/login']">Login</a>
          <a *ngIf="!currentUseInfo.name" class="btn btn-primary" [routerLink]="['/auth/signup']">Sign Up</a>

          <a *ngIf="currentUseInfo.name" class="header-user-icon-name" [routerLink]="[currentUseInfo?.role === 'Customer' ? '/customer/customer-profile' : '/driver/driver-profile']">
            <img [src]="currentUseInfo?.image ? currentUseInfo?.image:'assets/img/user.png'">
            {{currentUseInfo.name}}</a>

            <div class="h-ngb-dropdown ml-3" ngbDropdown>
                <a class="h-ngb-dropdown-link" ngbDropdownToggle id="navbarDropdown1">
                    <i class="fa fa-bars"></i>
                </a>
                <div ngbDropdownMenu aria-labelledby="navbarDropdown1" class="dropdown-menu">
                    <a ngbDropdownItem [routerLink]="['/about-us']">About Us</a>
                    <!-- <a ngbDropdownItem [routerLink]="['/']">Career</a> -->
                    <a ngbDropdownItem [routerLink]="['/how-it-works']">How Wooffer works</a>
                    <a ngbDropdownItem [routerLink]="['/safety']">Safety</a>
                    <a ngbDropdownItem [routerLink]="['/investors']">Investor Relations</a>
                    <a ngbDropdownItem [routerLink]="['/blog']">Blogs</a>
                    <a ngbDropdownItem [routerLink]="['/help']">Help</a>
                    <a ngbDropdownItem [routerLink]="['/contact-us']">Contact Us</a>
                    <a *ngIf="currentUseInfo.name" ngbDropdownItem (click)="LogoutUser()">Logout</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </header>
